import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class WhyChooseHome extends React.Component{

    constructor(){
        super();

        
        this.state = { 
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
        if(JSON.parse(localStorage.getItem("settings")))
        {
            this.setState({settings:JSON.parse(localStorage.getItem("settings"))}) ;
            this.setState({loading:0})
        }
        else{
            axios.get(api_base_url+"settings").then(response=>{
                this.setState({settings:response.data}) ;
            });
        }
        if(JSON.parse(localStorage.getItem("page_content")))
        {
            this.setState({page_content:JSON.parse(localStorage.getItem("page_content"))}) ;
        }
        else
        {
            axios.get(api_base_url+"page_content").then(response=>{
                this.setState({page_content:response.data}); 
                this.setState({loading:0})
            }); 
        }
        
    }


    render()
    { 
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
        
             <div class="section-full bg-orange p-t80 p-b50 bg-no-repeat bg-left-center" style={{backgroundImage:'url(images/background/why-choose-pic-2.png)' }}>
            	<div class="container">
                    
                    <div class="section-head text-center">
                        <h2 class="text-uppercase" style={{color: '#fff'}}>Why Choose us</h2>
                        <div class="wt-separator-outer" style={{color: '#fff'}}>
                            <div class="wt-separator style-square"  style={{color: '#fff'}}>
                                <span class="separator-left site-bg-primary"></span>
                                <span class="separator-right site-bg-primary"></span>
                            </div>
                        </div>
                        
                    </div>
                     
                    <div class="section-content">
                        <div class="row">
                        
                            
                            <div class="col-lg-4 col-md-6 col-sm-6 m-b10 animate_line">
                                <div class="wt-icon-box-wraper  p-a30 center bg-white">
                                    <div class="icon-lg site-text-primary m-b20">
                                         <img src={this.props.content[23].image} alt=""/> 
                                    </div>
                                    <div class="icon-content">
                                        <h5 class="wt-tilte text-uppercase">{this.props.content[23].title}</h5>
                                        <div  dangerouslySetInnerHTML={{ __html: this.props.content[23].description}} />  
                                    </div>
                                </div>
                            </div>
                           
                            <div class="col-lg-4 col-md-6 col-sm-6 m-b10 animate_line">
                                <div class="wt-icon-box-wraper  p-a30 center bg-white">
                                    <div class="icon-lg site-text-primary m-b20">
                                        <img src={this.props.content[24].image} alt=""/> 
                                    </div>
                                    <div class="icon-content ">
                                        <h5 class="wt-tilte text-uppercase">{this.props.content[24].title}</h5>
                                        <div  dangerouslySetInnerHTML={{ __html: this.props.content[24].description}} />  
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-lg-4 col-md-6 col-sm-6 m-b10 animate_line">
                                <div class="wt-icon-box-wraper  p-a30 center bg-white">
                                    <div class="icon-lg site-text-primary m-b20">
                                        <img src={this.props.content[25].image} alt=""/> 
                                    </div>
                                    <div class="icon-content">
                                        <h5 class="wt-tilte text-uppercase">{this.props.content[25].title}</h5>
                                        <div  dangerouslySetInnerHTML={{ __html: this.props.content[25].description}} />  
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-lg-4 col-md-6 col-sm-6 m-b10 animate_line">
                                <div class="wt-icon-box-wraper  p-a30 center bg-white">
                                    <div class="icon-lg site-text-primary m-b20">
                                        <img src={this.props.content[26].image} alt=""/> 
                                    </div>
                                    <div class="icon-content">
                                        <h5 class="wt-tilte text-uppercase">{this.props.content[26].title}</h5>
                                        <div  dangerouslySetInnerHTML={{ __html: this.props.content[26].description}} />  
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-lg-4 col-md-6 col-sm-6 m-b10 animate_line">
                                <div class="wt-icon-box-wraper  p-a30 center bg-white">
                                    <div class="icon-lg site-text-primary m-b20">
                                        <img src={this.props.content[27].image} alt=""/> 
                                    </div>
                                    <div class="icon-content">
                                        <h5 class="wt-tilte text-uppercase">{this.props.content[27].title}</h5>
                                        <div  dangerouslySetInnerHTML={{ __html: this.props.content[27].description}} />  
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-lg-4 col-md-6 col-sm-6 m-b10 animate_line">
                                <div class="wt-icon-box-wraper  p-a30 center bg-white">
                                    <div class="icon-lg site-text-primary m-b20">
                                        <img src={this.props.content[28].image} alt=""/> 
                                    </div>
                                    <div class="icon-content">
                                        <h5 class="wt-tilte text-uppercase">{this.props.content[28].title}</h5>
                                        <div  dangerouslySetInnerHTML={{ __html: this.props.content[28].description}} />  
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
       
 
    );
}

}

export default WhyChooseHome;